module.exports = __webpack_public_path__ + "img/load-4-3.b3d5a546.png";